import PropTypes from 'prop-types';

export const optionPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  content: PropTypes.object,
});

const optionListPropTypes = PropTypes.arrayOf(optionPropTypes);

export default optionListPropTypes;
